// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/modal.css
// module id = 1812
// module chunks = 0